export default (label, max = 0) => ({
  max,
  type: 'number',
  message: `${label} must be less than ${max}.`,
  trigger: 'blur',
})
